import React from 'react';
import {chartOverview} from '../../chart/config';
import {Select} from 'antd';
const Option = Select.Option;

 const EconomicOverviewDropdown = (props) => {

  const onEconomicOverviewChange = (value) => {
    props.onEconomicOverviewChange(value);
  };

  return (
    <Select size="large" style={{ width: 300 }}
      className="overview"
      value={props.overviewChartSelected}
      onChange={value => onEconomicOverviewChange(value)}
      >
      {Object.keys(chartOverview).map((key) => {
        //console.log('key', key, 'value', chartOverview[key])
        return <Option key={key} value={key}>{chartOverview[key]}</Option>
      })}
    </Select>
  )
  
}
export default EconomicOverviewDropdown


// WEBPACK FOOTER //
// ./src/components/economicProfile/EconomicOverviewDropdown.js